export default __webpack_public_path__ + "static/media/1853.ffa0932b.png";